import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconSizes, IconTypes } from '../foundations/Icon';
import Tooltip from './Tooltip';
import css from './KpiTile.css';

const DELTA_ICONS = { up: 'chevron-up', down: 'chevron-down', flat: null };

export const KPI_TILE_VARIANTS = {
    POSITIVE: 'positive',
    NEGATIVE: 'negative',
    NEUTRAL: 'neutral',
};

const deltaShape = PropTypes.shape({
    text: PropTypes.string.isRequired,
    direction: PropTypes.oneOf(Object.keys(DELTA_ICONS)),
    variant: PropTypes.oneOf(Object.values(KPI_TILE_VARIANTS)),
});

export const KpiDelta = ({ delta }) => (
    <span className={classNames(css.delta, css[delta.variant])}>
        {DELTA_ICONS[delta.direction] && (
            <Icon
                className={css.arrow}
                type={IconTypes.TABLER}
                name={DELTA_ICONS[delta.direction]}
                size={IconSizes.XX_SMALL}
                interactive={false}
            />
        )}
        <span>{delta.text}</span>
    </span>
);

KpiDelta.propTypes = {
    delta: deltaShape.isRequired,
};

const KpiTile = ({ label, value, valueTooltip = null, delta = null, comparisonLabel = null, compact = false }) => {
    const valueElement = <div className={css.value}>{value}</div>;

    return (
        <div className={classNames(css.card, { [css.compact]: compact })}>
            <div className={css.label} title={label}>
                {label}
            </div>
            <div className={css.valueBlock}>
                {valueTooltip ? <Tooltip title={valueTooltip}>{valueElement}</Tooltip> : valueElement}
                {(delta || comparisonLabel) && (
                    <div className={css.footer}>
                        {delta && <KpiDelta delta={delta} />}
                        {comparisonLabel && <span className={css.comparison}>{comparisonLabel}</span>}
                    </div>
                )}
            </div>
        </div>
    );
};

KpiTile.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.node.isRequired,
    valueTooltip: PropTypes.string,
    delta: deltaShape,
    comparisonLabel: PropTypes.string,
    compact: PropTypes.bool,
};

export default KpiTile;
